import React from 'react';
import { connect } from 'react-redux';

import Store from 'services/StoreService';
import Loader from 'components/Loader';
import GridItem from 'components/Grid/GridItem.jsx';
import GridContainer from 'components/Grid/GridContainer.jsx';
import { displayError } from 'store/actions/errorActions';
import { updateUserData } from 'store/actions/userActions';
import { spotifyAuthorizationUrl } from 'config/spotifyConfig';
import { Button } from '@material-ui/core';

const AllowSpotifyAccess = ({ uid, displayError, updateUserData, history }) => {
  const onSkip = async () => {
    try {
      const spotifyAuth = { status: 'denied', on: Date.now() };
      await Store.updateUser(uid, { spotifyAuth });
      updateUserData({ spotifyAuth });
      history.push('/profile');
    } catch (error) {
      console.error(error);
      displayError('Could not register your choice');
    }
  };

  return !uid ? (
    <div style={{ marginTop: '200px' }}>
      <Loader />
    </div>
  ) : (
    <GridContainer
      justify='center'
      style={{ padding: '0 50px', textAlign: 'center' }}
    >
      <GridItem xs={12}>
        <h2>Spotify Access</h2>
        <p
          style={{
            margin: '80px 0',
            fontSize: '20px',
            lineHeight: '1.4em',
          }}
        >
          Spotify will enhance your Fynda experience
        </p>
      </GridItem>
      <GridItem xs={12} style={{ margin: '40px 0' }}>
        <Button
          style={{
            color: '#555',
            fontSize: '18px',
            border: '1px solid #222',
            padding: '10px 20px',
            borderRadius: '50px',
          }}
        >
          <a
            href={spotifyAuthorizationUrl}
            alt='Spotify authorization'
            style={{
              color: '#757575',
              fontSize: '18px',
            }}
          >
            Allow Access
          </a>
        </Button>
      </GridItem>
      <GridItem xs={12}>
        <Button
          style={{
            color: '#555',
            fontSize: '18px',
            fontWeight: 'normal',
            padding: '10px 30px',
            border: '1px solid #222',
            borderRadius: '40px',
          }}
          onClick={onSkip}
        >
          Skip
        </Button>
      </GridItem>
    </GridContainer>
  );
};

const mapStateToProps = (state) => {
  const { uid } = state.user;
  return { uid };
};

export default connect(mapStateToProps, { displayError, updateUserData })(
  AllowSpotifyAccess
);
